export default {
      id: "watch-usage",
      viewBox: "0 0 11 11",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#watch-usage",
      toString: function () {
        return this.url;
      }
    }